/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsViewModel } from "../types/CourseDocumentsViewModel.ts";
import { eDocumentTypeSchema } from "./eDocumentTypeSchema.ts";

export const courseDocumentsViewModelSchema = z.object({
  documentId: z
    .number()
    .int()
    .describe("ID do documento do curso. Opcional.")
    .nullish(),
  documentName: z.string().describe("Nome do documento do curso.").nullish(),
  documentType: z.optional(
    z
      .lazy(() => eDocumentTypeSchema)
      .describe(
        "0 = CourseDocument | 1 = Syllabus | 2 = Contract | 3 = Manual | 4 = MonographDefense | 5 = FinishCourseCertificate | 6 = UspDocument | 7 = Regiment | ",
      ),
  ),
  cultureInfo: z
    .string()
    .describe("Código de cultura do idioma do documento (ex: pt-BR, en-US).")
    .nullish(),
  urlDownload: z
    .string()
    .describe("URL para download do arquivo do documento.")
    .nullish(),
}) as unknown as ToZod<CourseDocumentsViewModel>;
